export default __webpack_public_path__ + "static/melttogether-b0de8868a8c455b3cc73df2942f7ee09.png";